module.exports = __webpack_public_path__ + "img/new-guide-img2.29abbf6e.png";